import { RemovePostPopupComponent } from './../remove-post-popup/remove-post-popup.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { MainShared } from 'src/app/presentation/general/shared/main-shared';
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import {
  BlogPostModel,
  BlogTagModel,
} from 'src/app/core/model/object/blog-model';
import { TextHelper } from 'src/app/utils/text-helper';
import { BlogShared } from '../../general/shared/blog-shared';
import { DateHelper } from 'src/app/utils/date-helper';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { LoadingShared } from '../../general/shared/loading-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { TribuneAnalyticsService } from 'src/app/data/repository/analytics-repository/tribune-analytics.service';
import { SimplePopupComponent } from '../simple-popup/simple-popup.component';
import { Subscription } from 'rxjs';
import { SetUsernameBottomsheetComponent } from '../set-username-bottomsheet/set-username-bottomsheet.component';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
import { BlogDataService } from 'src/app/data/repository/blog-repository/blog-data.service';
import { BlogUserBanPopupComponent } from '../blog-user-ban-popup/blog-user-ban-popup.component';

@Component({
  selector: 'app-post',
  templateUrl: './post.component.html',
  styleUrls: ['./post.component.scss'],
})
export class PostComponent implements OnInit, OnDestroy {
  @Input() id: number;
  @Input() post: BlogPostModel;
  @Input() username: string;
  @Input() loadImage: boolean;

  tagRegex =
    /(#[^\u2000-\u206F\u2E00-\u2E7F\s\\'!"#$؟%&()*+،,\-.\/:;<=>?@\[\]^`{|}~]*)/g;
  mentionRegex = /(@)(?!\.)(?!\S*\.\.)(?!\S*\.[\s|$])([a-z0-9\.]+)(?=\s|$)/g;
  dateLabelString: string;
  showMore = true;
  isPersian = false;
  hasMention = false;
  postTextHtml: string;

  subscription1: Subscription;
  subscription2: Subscription;

  constructor(
    private textHelper: TextHelper,
    private dateHelper: DateHelper,
    private blogShared: BlogShared,
    private blogService: BlogService,
    private loadingShared: LoadingShared,
    private snackBarService: SnackBarService,
    private tribuneAnalytics: TribuneAnalyticsService,
    private mainShared: MainShared,
    private dialog: MatDialog,
    private matBottomSheet: MatBottomSheet,
    private blogData: BlogDataService
  ) {}

  ngOnInit() {
    this.subscription1 = this.blogShared.simplePopupActionObs$.subscribe(
      (action) => {
        if (
          action &&
          this.post.id === this.blogShared.selectedRemovingPostId &&
          this.id === this.blogShared.selectedRemovingId
        ) {
          const dialogRef = this.dialog.open(RemovePostPopupComponent, {
            data: { postId: this.post.id, id: this.id },
            width: '90%',
            panelClass: 'custom-dialog-container',
          });
        }
      }
    );
    this.subscription2 = this.blogShared.usernameChangeObs$.subscribe(
      (changed) => {
        if (changed) {
          this.username = this.blogShared.newUsername;
        }
      }
    );

    let _this = this;
    this.isPersian = this.textHelper.hasTextPersian(this.post.text);
    this.hasMention = this.textHelper.textHasMention(this.post.text);
    this.showMore = this.textHelper.isShowMoreNeeded(this.post.text);
    this.dateLabelString = this.dateHelper.getPostTimeLabel(
      this.post.createdAt
    );

    setTimeout(() => {
      if (this.post.text) {
        this.postTextHtml = this.textHelper.convertTextToHtml(
          this.post.text,
          this.tagRegex,
          this.mentionRegex
        );

        document.getElementById('postText' + this.post.id + this.id).innerHTML =
          this.postTextHtml;
        document.querySelectorAll('.hashTag').forEach((el) => {
          // console.log(el, el.getAttribute('listener'))
          if (el.getAttribute('listener') !== 'true') {
            el.addEventListener('click', function (e) {
              // console.log(this.innerHTML)
              _this.openBlogWithTag(this.innerHTML);
            });
            el.setAttribute('listener', 'true');
          }
        });
        document.querySelectorAll('.mention').forEach((el) => {
          // console.log(el, el.getAttribute('listener'))
          if (el.getAttribute('listener') !== 'true') {
            el.addEventListener('click', function (e) {
              // console.log(this.innerHTML)
              _this.openDetail();
            });
            el.setAttribute('listener', 'true');
          }
        });
      }
    }, 0);
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
  }

  postMoreOptions() {
    if (this.checkUsername()) {
      if (this.username === this.post.user.userName) {
        this.blogShared.selectedRemovingPostId = this.post.id;
        this.blogShared.selectedRemovingId = this.id;
        const dialogRef = this.dialog.open(SimplePopupComponent, {
          data: { titles: ['حذف پست'] },
          width: '90%',
          panelClass: 'custom-dialog-container',
        });
      } else {
        this.mainShared.openReportBottomsheet(this.post.id);
      }
    }
  }

  likeSelected() {
    if (this.checkUsername()) {
      this.loadingShared.showLoading();
      if (this.post.isLiked) {
        this.blogService.postDislike(this.post.id).then((res) => {
          if (res.isSuccess()) {
            this.post.isLiked = false;
            this.post.likes--;
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
      } else {
        this.blogService.postLike(this.post.id).then((res) => {
          if (res.isSuccess()) {
            this.post.isLiked = true;
            this.post.likes++;
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
      }
    }
  }

  commentSelected() {
    // this.blogShared.blogOpenDetailComments(this.id.toString(), this.post.id);
    this.blogData.setScroolStatus(true);
    this.blogData.setPost(this.post);
    this.blogService.goToUserPost(this.post.user.userName, this.post.id);
  }

  openDetail() {
    // this.blogShared.blogOpenDetail(this.id.toString(), this.post.id);
    this.blogData.setPost(this.post);
    this.blogService.goToUserPost(this.post.user.userName, this.post.id);
  }

  openBlogWithTag(tagTitle: string) {
    // console.log('tag', tagTitle)
    this.blogShared.blogSelectedTag = new BlogTagModel('', tagTitle, 0);
    this.blogShared.openBlogWithTag(this.id);
    this.tribuneAnalytics.analyticTribuneHashtagClicked();
  }

  openProfile() {
    if (this.id === 10) {
      // this.blogShared.blogOpenProfile(this.post.user.userName);
      this.blogService.goToUserProfile(this.post.user.userName);
    } else {
      this.openDetail();
    }
  }

  sharePost() {
    let newVariable: any;
    newVariable = window.navigator;
    if (newVariable && newVariable.share) {
      newVariable
        .share({
          url: 'https://bentoapp.info/posts/' + this.post.id,
        })
        .catch((e) => {
          this.snackBarService.showSnackBar('خطا در اشتراک گذاری');
        });
    } else {
      // this.snackBarService.showSnackBar('اشتراک گذاری در جست‌و‌جوگر شما پشتیبانی نمیشود');
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = 'https://bentoapp.info/posts/' + this.post.id;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.snackBarService.showSnackBar('لینک پست کپی شد');
    }
  }

  follow() {
    if (this.checkUsername()) {
      this.blogService.follow(this.post.user.id).then((res) => {
        if (res.isSuccess()) {
          this.post.featured = false;
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
      });
    }
  }

  showBanPopup() {
    // const dialogRef = this.dialog.open(BlogUserBanPopupComponent, {
    //   width: '90%',
    //   panelClass: 'custom-dialog-container',
    // });
  }

  checkUsername(): boolean {
    if (this.username === '') {
      this.matBottomSheet.open(SetUsernameBottomsheetComponent, {
        panelClass: 'custom-bottomsheet-container',
      });
      return false;
    }
    return true;
  }
}
